import * as Auth from './authentication'
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: () => import(/* webpackChunkName: "forbidden" */ '@/views/auth/Forbidden.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/Main.vue'),
    children: [
      {
        path: 'create-user',
        name: 'CreateUser',
        component: () => import(/* webpackChunkName: "create-user" */ '@/views/admin/CRUD/CreateUser.vue'),
        beforeEnter: Auth.requiresAdmin
      }
    ],
    beforeEnter: Auth.requiresAdmin,
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/auth/Login.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => Auth.logOut()
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "register" */ '@/views/auth/Register.vue')
  },
  {
    path: '/',
    name: 'default',
    component: () => import(/* webpackChunkName: "main" */ '@/views/default/Main.vue'),
    redirect: { name: 'Home' },
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import(/* webpackChunkName: "home-page" */ '@/views/default/pages/HomePage.vue'),
        beforeEnter: Auth.requiresModeratorOrUser
      },
      {
        path: 'node',
        name: 'NodeData',
        component: () => import(/* webpackChunkName: "node-data-page" */ '@/views/default/pages/NodeData.vue'),
        beforeEnter: Auth.requiresModeratorOrUser
      },
      {
        path: 'buiten-gebruik',
        name: 'EMRAsOutOfUse',
        component: () => import(/* webpackChunkName: "out-of-use-page" */ '@/views/default/pages/OutOfUsePage.vue'),
        beforeEnter: Auth.requiresModerator
      },
      {
        path: 'preparatie',
        name: 'EMRAsPrepared',
        component: () => import(/* webpackChunkName: "prepared-emras-page" */ '@/views/default/pages/PreparationPage.vue'),
        beforeEnter: Auth.requiresModerator
      },
      {
        path: 'emra',
        children: [ 
          {
            path: '',
            name: 'EMRAPage',
            component: () => import(/* webpackChunkName: "emra-page" */ '@/views/default/pages/EMRAPage.vue'),
            beforeEnter: Auth.requiresModerator
          },
          {
            path: 'rapportage',
            component: () => import(/* webpackChunkName: "report" */ '@/views/default/pages/report/ReportPage.vue'),
            beforeEnter: Auth.requiresModerator,
            children: [
              {
                path: 'berekeningen',
                name: 'ModNode',
                component: () => import(/* webpackChunkName: "report-data" */ '@/views/default/pages/report/DataPage.vue'),
                beforeEnter: Auth.requiresModerator
              },
              {
                path: 'grafieken',
                name: 'ReportGraphs',
                component: () => import(/* webpackChunkName: "report-graphs" */ '@/views/default/pages/report/GraphsPage.vue'),
                beforeEnter: Auth.requiresModerator
              },
            ],
          },
          {
            path: 'metingen',
            name: 'DataPage',
            component: () => import(/* webpackChunkName: "data-page" */ '@/views/default/pages/DataPage.vue'),
            beforeEnter: Auth.requiresModeratorOrUser
          }
        ] 
      },
      {
        path: 'toevoegen',
        name: 'AddEMRA',
        component: () => import(/* webpackChunkName: "add-emra" */ '@/views/default/pages/AddEMRA.vue'),
        beforeEnter: Auth.requiresModerator
      },
      {
        path: 'gebruikers',
        name: 'UsersPage',
        component: () => import(/* webpackChunkName: "users" */ '@/views/default/pages/UsersPage.vue'),
        beforeEnter: Auth.requiresModerator
      }
    ],
    beforeEnter: Auth.requiresModeratorOrUser
  },
  {
    path: '/(.*)',
    redirect: '/login'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  Auth.keepAliveHealthyTokens()
  next()
})


export default router
